import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const TermsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6541">
      <Navbar scrolled={scrolled} data-id="element-6542" />
      <main className="pt-24 pb-20" data-id="element-6543">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6544">
          <div className="max-w-4xl mx-auto" data-id="element-6545">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6546">
              Terms of Service
            </h1>
            <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-6547">
              Last updated: March 16, 2026
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-6548" />
    </div>;
};